import { Component, OnDestroy, OnInit } from '@angular/core';
import { MediaService } from '../../services/media.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'dashboard-page',
    templateUrl: './dashboard.page.html',
    styleUrls: ['./dashboard.page.css']
})
export class DashboardPage implements OnInit, OnDestroy {
    ImageURL: string;
    Subscription: Subscription;

    ngOnInit(): void {
        this.Subscription = MediaService.ExternalImageURL.subscribe(x => {
            if (!x.endsWith('/')) {
                x += '/';
            }
            this.ImageURL = x;
        });
    }

    ngOnDestroy(): void {
        if (this.Subscription) {
            this.Subscription.unsubscribe();
            this.Subscription = null;
        }
    }
}
